/**
 * Order installments by the SESSION calendar, taken from the month name of the installment
 * ("April to June" -> April). Session starting 01-04 -> April, May ... March.
 * A start date after the 25th (e.g. 31-03-2026) counts as the next month (April).
 * Works even when an installment's stored due date / orderno is wrong.
 */
const MONTHS = ["january", "february", "march", "april", "may", "june",
  "july", "august", "september", "october", "november", "december"];

export const sessionStartMonthIdx = (startdate) => {
  if (!startdate) return 3; // April
  const d = new Date(startdate);
  if (isNaN(d.getTime())) return 3;
  return (d.getMonth() + (d.getDate() > 25 ? 1 : 0)) % 12;
};

export const monthIdxOf = (label) => {
  const first = String(label || "").trim().split(/\s+|,/)[0].toLowerCase();
  const i = MONTHS.findIndex((m) => m === first || m.slice(0, 3) === first.slice(0, 3));
  return first ? i : -1;
};

/** position of the installment inside the session (0 = first month), 99 when the name has no month */
export const sessionPos = (inst, startIdx) => {
  const i = monthIdxOf(inst?.month);
  return i < 0 ? 99 : (i - startIdx + 12) % 12;
};

export const sortBySession = (list, startIdx) =>
  [...(list || [])].sort((a, b) => {
    const pa = sessionPos(a, startIdx);
    const pb = sessionPos(b, startIdx);
    if (pa !== pb) return pa - pb;
    const da = a.due_date ? new Date(a.due_date).getTime() : 0;
    const db = b.due_date ? new Date(b.due_date).getTime() : 0;
    return da - db || (Number(a.orderno) || 0) - (Number(b.orderno) || 0);
  });
